import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ScreenSizeDetectorService, UiKitModule } from '@serviceplan/ui-kit';
import { ClientCoreModule, ClientEnvironment, ENVIRONMENT, FilterFormDataModel, SearchAssetsFieldPlaceholder, ViewType, anyAsset } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { AnyType } from '@thehubz/shared/model';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';
import { AssetViewTypeService } from '../../../services/asset-view-type.service';
import { AssetBulkEditComponent } from '../../asset-bulk-edit/asset-bulk-edit.component';
import { MenuSettingsData } from './../menu-settings-data';

@Component({
  selector: 'thehubz-assets-actions',
  templateUrl: './assets-actions.component.html',
  styleUrls: ['./assets-actions.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatMenuModule, ClientCoreModule, UiKitModule, AssetBulkEditComponent, TourMatMenuModule],
})
export class AssetsActionsComponent {
  @Input() hideBulkEdit!: boolean;
  @Input() filterBubbles: AnyType;
  @Input() projectFlag!: boolean;
  @Input() showUploadBtn!: boolean;
  @Input() configObject!: AnyType;
  @Input() bulkEditAccessibility!: boolean;
  @Input() assetCount!: number;
  @Input() showEmptyState!: boolean;
  @Input() searchText!: string;
  @Input() appliedFilters!: number;
  @Input() filterAssetFormData!: FilterFormDataModel;
  @Input() selectedFilterObject!: AnyType;
  assetGalleryMenuObject = MenuSettingsData.ASSET_MENU_SETTINGS.concat(MenuSettingsData.ASSET_GALLERY_MENU_SETTINGS);
  assetTableMenuObject = MenuSettingsData.ASSET_MENU_SETTINGS.concat(MenuSettingsData.ASSET_TABLE_MENU_SETTINGS);
  @Input() selectedViewType!: ViewType;
  @Input() selectedViewSection2!: ViewType;
  @Input() sortByNew!: boolean;
  @Input() gridSettingsKeySuffix = '';
  @Input() tableData: AnyType;

  @Output() uploadClick = new EventEmitter();
  @Output() selectAll = new EventEmitter<AnyType>();
  @Output() unselectAll = new EventEmitter();
  @Output() searchTextChanged = new EventEmitter<string>();
  @Output() clearSearch = new EventEmitter<string>();
  @Output() toggleMobileSearch = new EventEmitter();
  @Output() restFormField = new EventEmitter();
  @Output() viewAssetTags = new EventEmitter();
  @Output() applyFilters = new EventEmitter<AnyType>();
  @Output() updateFormData = new EventEmitter<AnyType>();
  @Output() changeAssetView = new EventEmitter<ViewType>();
  @Output() sortToggle = new EventEmitter<ViewType>();
  @Output() editSelectedAsset = new EventEmitter<AnyType>();
  @Output() toggleSidebar = new EventEmitter();
  @Output() addOnEnter = new EventEmitter();
  @Output() updateAssetDraft = new EventEmitter();
  @Output() showAssetMismatchDialog = new EventEmitter();

  AnyAsset = anyAsset;
  brandingKey: CustomClients;
  CustomClients = CustomClients;
  searchPlaceholder = SearchAssetsFieldPlaceholder;
  bulkEditButtonText = $localize`Bulk edit`;

  constructor(
    @Inject(ENVIRONMENT) protected readonly env: ClientEnvironment,
    protected assetViewTypeService: AssetViewTypeService,
    protected screenSizeDetectorService: ScreenSizeDetectorService,
  ) {
    this.brandingKey = this.env.brandingKey;
  }
}
